"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEnv = void 0;
var NodeEnv;
(function (NodeEnv) {
    NodeEnv["production"] = "production";
    NodeEnv["migration"] = "migration";
    NodeEnv["development"] = "development";
    NodeEnv["staging"] = "staging";
    NodeEnv["test"] = "test";
})(NodeEnv || (exports.NodeEnv = NodeEnv = {}));
//# sourceMappingURL=NodeEnv.js.map